export default "__VITE_ASSET__67f223a4__"